import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("./s1Login.vue"),
  },
  {
    path: "/s1hub/:slug",
    name: "S1 Content Page",
    component: () => import("./s1ContentPage.vue"),
    props: true,
  },
] satisfies RouteRecordRaw[];
